import { render, staticRenderFns } from "./advertiser-details.vue?vue&type=template&id=0c1c9352"
import script from "./advertiser-details.vue?vue&type=script&lang=js"
export * from "./advertiser-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports